const state = {
    isBuscando:false,
    contribuyentes:[],
    contribuyenteActual:null/*{
                            tipoPadron:"4",
                            clave:"0899999", isBloquearCobro:false, ubicacion:"Av. Benito Juarez No. 212", nombre:"Juan Perez", direccion:"Av. Benito Juarez No. 212", curp:"PELJ900506HMCXFL04", rfc:"PELJ900506HMC", correo:"juan@gmail.com", telefono:"5566993322", 
                            obs:"xxx", isNotificado:true, noActos:"7",
                            //basesFiscales:[//1
                              //      {año:"2010", valorCatastral:"500,000", valorTerrenoPropio:"300,000", valorTerrenoComun:"300,000", valorConstruccionPropia:"0.00",valorConstruccionComun:"0.00",superficieTerrenoPropio:"0.00",superficieTerrenoComun:"0.00",superficieConstruccionPropia:"0.00",superficieConstruccionComun:"0.00",tipoUso:"0.00",regimenPropiedad:"0.00"}
                                //],
                            //basesFiscales:{tipo:"ejemplo", fechaInicio:"2020-02-02"},//2,8
                            basesFiscales:{tipo:"ejemplo", fechaInicio:"2020-02-02", dimension:"50"},//4,5,6,7
                            pagos:[
                                    {nombre:"", fecha:"", folio:"", ordenPago:"", año:"", mesIni:"", mesFin:"",importe:"", actualizacion:"", recargo:"", multa:"", gastoEjec:"", subImp:"", subRec:"", subMult:"", subGto:"", total:"", tipo:"", usuario:""}
                                ],
                            movimientos:[
                                    //{tipo:"", valorAnterior:"", valorNuevo:"", usuario:"", fecha:"", obs:""}
                                    {movimiento1:"0.00", movimiento2:"0.00", movimiento3:"0.00", movimiento4:"0.00"}
                                ],
                            coordenadas:{lat:"", lng:""}
                        }*/,
    catalogoPadrones:null, //va a tener tipoPadrones, tiposRegimen, tiposUso, tiposLicenciaBebida....
    optionsSelectTipo:null,
    modelSelectTipo:null,
    msgErrorPadrones:'',
    msgErrorFusion:'',
    msgErrorSubdividir:'',
    opcionFuncionPadron:null,

    /*****Formulario de busqueda****** */
    tipoPadron:"",
    tipoBusqueda:"Clave de contribuyente",
    dato1Agua:null,
    dato1Manifestacion:null,
    claveContribuyente:"",
    nombreContribuyente:null,
    ubicacionContribuyente:null,
    isShowFormBusqueda:true,
    tabIndex:1
}

// mutations
const mutations = {
    configOptionsSelectTipos(state, tipoPadron){
        if(tipoPadron == 2){
            state.optionsSelectTipo = state.catalogoPadrones.tiposLicenciaBebida;
        }else if(tipoPadron == 4){
            state.optionsSelectTipo = state.catalogoPadrones.tiposLicenciaJuegos;
        }else if(tipoPadron == 5){
            state.optionsSelectTipo = state.catalogoPadrones.tiposLicenciaAnuncios;
        }else if(tipoPadron == 6){
            state.optionsSelectTipo = state.catalogoPadrones.tiposLicenciaComercio;
        }else if(tipoPadron == 7){
            state.optionsSelectTipo = state.catalogoPadrones.tiposLicenciaEstaciones;
        }else if(tipoPadron == 8){
            state.optionsSelectTipo = state.catalogoPadrones.tiposLicenciaPanteones;
        }
    },
    updateOpcionFuncionPadron(state, newState){
        state.opcionFuncionPadron = newState;
    },
    updateMsgErrorPadrones(state, newMsgErrorPadrones){
        state.msgErrorPadrones = newMsgErrorPadrones;
    },
    updateMsgErrorFusion(state, newM){
        state.msgErrorFusion = newM;
    },
    updateMsgErrorSubdividir(state, newM){
        state.msgErrorSubdividir = newM;
    },
    updateCatalogoPadrones(state, newCatalogoPadrones){
        state.catalogoPadrones = newCatalogoPadrones;
    },
    updateColoniaCatalog(state, newColonia){
        state.catalogoPadrones.colonias.push(newColonia);
    },
    updateLocalidadCatalog(state, newLocalidad){
        state.catalogoPadrones.localidades.push(newLocalidad);
    },
    updatePagosContribuyenteActual(state, newPagosContribuyenteActual){
        state.contribuyenteActual.pagos = newPagosContribuyenteActual;
    },
    quitarPagoContribuyenteById(state, idTran){
        for(const idx in state.contribuyenteActual.pagos  ){
            if(state.contribuyenteActual.pagos[idx].idTran == idTran){
                state.contribuyenteActual.pagos.splice(idx, 1);
            }
        }
        
    },
    updateMovimientosContribuyenteActual(state, newMovimientosContribuyenteActual){
        state.contribuyenteActual.movimientos = newMovimientosContribuyenteActual;
    },
    updateExpedientesContribuyenteActual(state, expedientesContribuyenteActual){
        state.contribuyenteActual.expedientes = expedientesContribuyenteActual;
    },
    updateCatOptionsTipoFiscal(state, newCatOptionsTipoFiscal){
        state.contribuyenteActual.catOptionsTipoFiscal = newCatOptionsTipoFiscal;
    },
    updateContribuyentes(state, newContribuyentes){
        state.contribuyentes = newContribuyentes;
    },
    cleanContribuyenteActual(state, newCon){
        state.contribuyenteActual = newCon==null?[]:newCon;
    },
    updateContribuyenteActual(state, newContribuyenteActual){
        state.contribuyenteActual = newContribuyenteActual;
        if(newContribuyenteActual!=null){ //puede ser null cuando se actualiza despues de eliminarlo
            if(state.contribuyenteActual.basesFiscales[0].fechaInicio != null){
                var fec = state.contribuyenteActual.basesFiscales[0].fechaInicio.split("/");
                state.contribuyenteActual.basesFiscales[0].fechaInicio = fec[2] + "-" + fec[1] + "-" + fec[0];
            }
        }
    },
    updateConsumosContribuyente(state, newConsumos){
        state.contribuyenteActual.basesFiscales[0].consumos = newConsumos;
    },
    updateIsBuscando(state, newIsBuscando){
        state.isBuscando = newIsBuscando;
    },


    updateTipoPadron(state, newDato){
        state.tipoPadron = newDato;
    },
    updateTipoBusqueda(state, newDato){
        state.tipoBusqueda = newDato;
    },
    updateDato1Agua(state, newDato){
        state.dato1Agua = newDato;
    },
    updateDato1Manifestacion(state, newDato){
        state.dato1Manifestacion = newDato;
    },
    updateClaveContribuyente(state, newDato){
        state.claveContribuyente = newDato;
    },
    updateNombreContribuyente(state, newDato){
        state.nombreContribuyente = newDato;
    },
    updateUbicacionContribuyente(state, newDato){
        state.ubicacionContribuyente = newDato;
    },
    updateIsShowFormBusqueda(state, newDato){
        state.isShowFormBusqueda = newDato;
    },
    updateTabIndex(state, newDato){
        state.tabIndex = newDato;
    },
}

export default {
    state,
    mutations
}